import styled from "@emotion/styled";
import { Box, TableHead, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AccountTypeEnum } from "@rentablo/api/apiv1";
import { MandatorConditional } from "@helpers";
import { SortableTableHeader, Table, TableRow } from "@rentablo/components";

const FullWidthSortableTableHeader = styled(SortableTableHeader)`
  width: 100%;
`;

const NoBorderTableRow = styled(TableRow)`
  height: 61px;
  & > th {
    border-bottom: none;
  }
`;

interface Props {
  type: AccountTypeEnum;
  sortField: string | undefined;
  sortDirection: TableSortDirection | undefined;
  onSort: (field: string) => void;
}

export const AccountsTableHeader = ({
  type,
  sortField,
  sortDirection,
  onSort,
}: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ gridColumn: "1 / -1" }}>
      <Table>
        <TableHead>
          <NoBorderTableRow>
            <MandatorConditional showFor={["kpmg-germany"]}>
              {!isSm && (
                <SortableTableHeader
                  align="left"
                  text={t("accounts.sort.reporting")}
                  sx={{
                    color: theme.palette.text.primary,
                    span: { width: 0, margin: 0 },
                  }}
                  sortByName="reporting"
                />
              )}
            </MandatorConditional>
            <FullWidthSortableTableHeader
              isSortable
              text={t("accounts.sort.name")}
              sortByName="name"
              sortField={sortField}
              sortDirection={sortDirection}
              onClick={onSort}
              id={`name-sortable-header-${type}`}
              data-testid={`name-sortable-header-${type}`}
              sx={{ color: theme.palette.text.primary }}
            />
            <SortableTableHeader
              isSortable
              text={t("accounts.sort.totalValue")}
              sortByName="performance"
              align="right"
              sortField={sortField}
              sortDirection={sortDirection}
              onClick={onSort}
              data-testid={`performance-sortable-header-${type}`}
              sx={{
                color: theme.palette.text.primary,
                minWidth: "200px",
              }}
            />
          </NoBorderTableRow>
        </TableHead>
      </Table>
    </Box>
  );
};
